<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
          
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getImportRecordListHandle">搜索查询</el-button>
            </el-form-item>
        </el-form>
        <el-button type="primary" class="onlyBtn" @click="showManyCardImport">批量回收</el-button>
        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column prop="importTime" label="回收时间" ></el-table-column>
            <el-table-column prop="importTotal" label="回收张数（张）" ></el-table-column>
            <el-table-column prop="importSuccess" label="回收成功张数（张）"></el-table-column>
            <el-table-column prop="importFail" label="回收失败张数（张）" ></el-table-column>
            <el-table-column prop="agentName" label="操作人" ></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.importFail > 0" type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">查看失败</el-button>
                </template>
            </el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/unSold/import/excel')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>  
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog> 
        <el-dialog title="回收失败卡列表" :visible.sync="importFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import {oneCardImport, getImportRecordListSold, getImportFailRecordListSold} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){   
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }
        return {  
            agentsOption:[],
            searchForm:{
                agentId:''
            },          
            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            importCardForm: {
                simType: '0',
                cardCategory: 'MP',
                supplierId: '',
                agentId: '',
                simPoolId: '',
                simLife: '',
                isVoice:'',
                packageId:null,
                simPrice:'',
                voiceGroupId:''
            },
            importCardVisible: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },       
            currentId_fail: '',
            supplierOption: [],
            packageOption: [],
            agentsOption: [],
            fluxPoolOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                iccid: [{required: true, validator: this.checkIccid, trigger: 'blur'}],
                intoNo: [{required: true, validator: this.checkIntoNo, trigger: 'blur'}],
                supplierCode: [{required: true, message: '请选择供应商', trigger: 'change'}],
                basePkgGroup: [{required: true, message: '请选择套餐组', trigger: 'change'}],
                cardType: [{required: true, message: '请选择卡类型', trigger: 'change'}]
            }
        }
    },
    methods: {
        cancel(){            
            this.importCardVisible = false; 
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList){
            if(fileList.length > 0){
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', {});
            getImportRecordListSold({"agentId":this.searchForm.agentId}).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event){
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordListSold(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport(){
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
        },
        getOptionsOfSelect(){       
            common.getSupplierOptsCom(this, 'supplierOption');    
            common.getNextAgentOptsCom(this, 'agentsOption');    
            common.getPackageOptsCom (this,'packageOption') 
        },
        changeAgent(){
            this.importCardForm.simPoolId = '';
            var data = {
                id: this.importCardForm.agentId
            }
            common.getFluxPoolOptsCom(this, 'fluxPoolOption', data)
        },
        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();   //号段批量导入
                }
            })           
        },
        exportHandle(){//导出excel文件
            var data = {};
            data.token = localStorage.getItem('token');
            this.exportExcel('/excel/sim/sold/template', data);
            this.$message.success('下载中……');
        },
        handleSuccess(res){
            if(res.code == 200){
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }  
    },
    created () {
        this.getImportRecordListHandle();
         
    } 
}
</script>

<style lang="less" scoped>

</style>

